import React, { Component } from "react"
import Button from "../Button"
import validator from "validator"

import "./requestAccessModal.scss"

class RequestAccessModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      first: "",
      last: "",
      email: "",
      phone: "",
      time: "",
      errors: {},
    }
  }

  onChangeField = (key) => (e) => {
    e.persist()
    this.setState(({ errors }) => ({
      [key]: e.target.value,
      errors: { ...errors, [key]: null },
    }))
  }

  onChangePhone = (e) => {
    e.persist()
    let value = e.target.value
    this.setState(({ errors }) => ({
      phone: value.replace(/[^\d\+]/g, ""),
      errors: { ...errors, phone: null },
    }))
  }

  onChangeTime = (e) => {
    e.persist()
    this.setState(({ errors }) => ({
      time: e.target.value,
      errors: { ...errors, time: null },
    }))
  }

  submit = () => {
    let { errors, ...fields } = this.state

    errors = Object.entries(fields).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: value ? undefined : "Required",
      }),
      {}
    )

    if (fields.email && !validator.isEmail(fields.email)) {
      errors.email = "Invalid email"
    }

    if (fields.phone && !validator.isMobilePhone(fields.phone, "any")) {
      errors.phone = "Invalid phone"
    }

    if (Object.values(errors).some((v) => !!v)) {
      this.setState({ errors })
    } else {
      this.props.submit(fields)
      this.setState({
        first: "",
        last: "",
        email: "",
        phone: "",
        time: "",
        errors: {},
      })
    }
  }

  _renderRequestAccessForm = () => {
    let { first, last, phone, time, email, errors } = this.state

    const inputItems = [
      {
        label: "First Name",
        value: first,
        placeholder: "First Name",
        onChange: this.onChangeField("first"),
        error: errors.first,
      },
      {
        label: "Last Name",
        value: last,
        placeholder: "Last Name",
        onChange: this.onChangeField("last"),
        error: errors.last,
      },
      {
        label: "Email",
        value: email,
        placeholder: "Email",
        onChange: this.onChangeField("email"),
        style: { width: "100%" },
        error: errors.email,
      },
      {
        label: "Phone",
        value: phone,
        placeholder: "123 456 7890",
        onChange: this.onChangePhone,
        error: errors.phone,
      },
      {
        label: "Contact Time",
        type: "time",
        value: time,
        onChange: this.onChangeTime,
        error: errors.time,
      },
    ]

    return (
      <div className="request-access-form">
        {inputItems.map(({ label, error, style, ...inputProps }, i) => (
          <div key={i} className="input-item" style={style}>
            <label>{label}</label>
            <input {...inputProps} />
            <div className="input-error">{error}</div>
          </div>
        ))}
      </div>
    )
  }

  _renderRequestAccessSuccess = () => (
    <div className="request-access-success">
      <span className="glyphicon glyphicon-ok success-icon" />
      <h3 className="green">
        <b>SUCCESS!</b>
      </h3>
      <h3>
        <b>Thank you for submitting your request</b>
      </h3>
      <h3>{this.props.successMessage}</h3>
    </div>
  )

  _renderRequestAccessButtons = () => {
    let buttons

    if (this.props.success) {
      buttons = [
        {
          classes: ["dark-fill", "small-caps"],
          fullWidth: true,
          action: this.props.close,
          text: "Ok",
        },
      ]
    } else {
      buttons = [
        {
          classes: ["dark-fill"],
          fullWidth: true,
          action: this.submit,
          text: "Submit",
        },
        {
          classes: ["grey-fill"],
          fullWidth: true,
          action: this.props.close,
          text: "Cancel",
        },
      ]
    }

    return (
      <div className="request-access-buttons">
        {buttons.map(({ text, ...buttonProps }, i) => (
          <Button key={i} {...buttonProps}>
            {text}
          </Button>
        ))}
      </div>
    )
  }

  render = () => {
    let { success } = this.props

    return (
      <div className={`request-access-modal-container ${success && "success"}`}>
        <h2>Request {success ? "Access" : ""}</h2>
        {success
          ? this._renderRequestAccessSuccess()
          : this._renderRequestAccessForm()}
        {this._renderRequestAccessButtons()}
      </div>
    )
  }
}

export default RequestAccessModal
